import { $ as e, A as t, C as n, F as r, L as i, S as a, U as o, V as s, _ as c, g as l, h as u, i as d, k as f, m as p, nt as m, ot as h, p as g, q as _, rt as v, t as y, v as b, w as x, z as S } from "./_plugin-vue_export-helper-CTQVpqU-.js";
import { n as C, t as w } from "./i18n-lite-BcmwMblk.js";
import { t as T } from "./Button.ce-Dstoud2U.js";
//#region src/webcomponents/usages-donnees/locales/de-AT.json
var E = {}, D = {}, O = {}, k = {}, A = { "usages-donnees": {
	"cloud-choice-title": "Ce que vous faites en ligne",
	"instruction-step-1": "Parmi les éléments suivants, séléctionnez ceux qui correspondent à ce que vous avez sur votre appareil.",
	"instruction-step-2": "Parmi les éléments suivants, séléctionnez ceux qui correspondent à ce que vous faites en ligne.",
	"last-step": {
		content: {
			"bold-1": "récupérer des données importantes, accéder",
			"bold-2": "de l'argent",
			"line-1": "Certaines données et certains usages ont beaucoup de valeur pour les pirates, d’autres ont moins de valeur.",
			"line-2": "Par exemple, en accédant à ces informations qui ont de la valeur, les pirates peuvent : {{bold1}} à vos différents services en ligne ou vous demander {{bold2}} (une rançon) pour réparer les dégâts qu'ils ont causés."
		},
		"title-1": "Données et usages avec plus de valeur",
		"title-2": "Données et usages avec moins de valeur"
	},
	"locale-choice-title": "Ce que vous avez sur votre appareil",
	next: "Suivant",
	result: "Voir mon bilan",
	"step-a11y": "Étape {{currentStep}} sur {{total}}"
} }, j = { "usages-donnees": {
	"instruction-step-1": "Parmi les éléments suivants, séléctionnez ceux qui correspondent à ce que vous avez sur votre appareil.",
	"instruction-step-2": "Parmi les éléments suivants, séléctionnez ceux qui correspondent à ce que vous faites en ligne.",
	"step-a11y": "Étape {{currentStep}} sur {{total}}",
	next: "Suivant",
	result: "Voir mon bilan",
	"locale-choice-title": "Ce que vous avez sur votre appareil",
	"cloud-choice-title": "Ce que vous faites en ligne",
	"last-step": {
		"title-1": "Données et usages avec plus de valeur",
		"title-2": "Données et usages avec moins de valeur",
		content: {
			"line-1": "Certaines données et certains usages ont beaucoup de valeur pour les pirates, d’autres ont moins de valeur.",
			"line-2": "Par exemple, en accédant à ces informations qui ont de la valeur, les pirates peuvent : {{bold1}} à vos différents services en ligne ou vous demander {{bold2}} (une rançon) pour réparer les dégâts qu'ils ont causés.",
			"bold-1": "récupérer des données importantes, accéder",
			"bold-2": "de l'argent"
		}
	}
} }, M = {}, N = {}, P = "data:image/svg+xml,%3csvg%20width='11'%20height='8'%20viewBox='0%200%2011%208'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M3.61484%205.80617L9.19317%200.227833C9.34506%200.0759442%209.52317%200%209.7275%200C9.93184%200%2010.11%200.0759442%2010.262%200.227833C10.4139%200.379833%2010.4898%200.560111%2010.4898%200.768667C10.4898%200.977222%2010.4139%201.1575%2010.262%201.3095L4.14934%207.43483C3.99734%207.58672%203.81917%207.66267%203.61484%207.66267C3.41051%207.66267%203.23234%207.58672%203.08034%207.43483L0.221671%204.57617C0.0697825%204.42417%20-0.00405093%204.24389%200.000171293%204.03533C0.00439352%203.82678%200.0824491%203.6465%200.234338%203.4945C0.386338%203.34261%200.566616%203.26667%200.775171%203.26667C0.983727%203.26667%201.164%203.34261%201.316%203.4945L3.61484%205.80617Z'%20fill='%23212A37'/%3e%3c/svg%3e", F = "label[data-v-bde39c2d]{border-radius:8px;align-items:center;gap:6px;display:flex;position:relative}label[data-v-bde39c2d]:not(.readonly):hover{cursor:pointer}label .custom-input[data-v-bde39c2d]{aspect-ratio:1;background-color:#fff;border:1px solid #000;justify-content:center;align-items:center;min-width:16px;display:flex}label .custom-input img[data-v-bde39c2d]{width:10px}label input:focus~.custom-input[data-v-bde39c2d]{outline:2px solid #000}.variant-a[data-v-bde39c2d]{background:#eaf1ff;padding:14px}.variant-a.is-checked[data-v-bde39c2d]{color:#fff;background:#2c75ff}.variant-b[data-v-bde39c2d],.variant-c[data-v-bde39c2d]{background:#f9f9f9;border-left:4px solid #c8cfd9;padding:8px 12px}.variant-b.is-checked[data-v-bde39c2d]{background:#fffaeb;border-left:4px solid #ffdc76}.variant-c.is-checked[data-v-bde39c2d]{background:#eaf1ff;border-left:4px solid #72a3ff}", I = ["for"], L = [
	"id",
	"checked",
	"readonly"
], R = ["src"], z = /*#__PURE__*/ y({
	__name: "CustomCheckbox.ce",
	props: {
		label: String,
		isSelected: Boolean,
		index: Number,
		variant: {
			type: String,
			default: "a"
		},
		readonly: {
			type: Boolean,
			default: !1
		}
	},
	emits: ["select"],
	setup(e, { emit: t }) {
		let n = s(), i = t;
		function o(t) {
			e.readonly || i("select", t.target.checked, e.index);
		}
		return (t, i) => (r(), b("label", {
			for: m(n),
			class: v({
				"is-checked": e.isSelected,
				[`variant-${e.variant}`]: !0,
				readonly: e.readonly
			})
		}, [
			u("input", {
				id: m(n),
				checked: e.isSelected,
				readonly: e.readonly,
				type: "checkbox",
				class: "sr-only",
				onChange: o
			}, null, 40, L),
			u("span", { class: v(["custom-input", { "is-checked": e.isSelected }]) }, [e.isSelected ? (r(), b("img", {
				key: 0,
				src: m(P),
				alt: ""
			}, null, 8, R)) : c("", !0)], 2),
			a(" " + h(e.label), 1)
		], 10, I));
	}
}, [["styles", [F]], ["__scopeId", "data-v-bde39c2d"]]), B = {
	key: 0,
	class: "instruction"
}, V = { key: 1 }, H = { class: "title" }, U = { class: "stepper" }, W = { class: "sr-only" }, G = { "aria-hidden": "true" }, K = { class: "checkbox-group" }, q = {
	key: 2,
	class: "result"
}, J = {
	class: "legend",
	style: { "--color": "#ffcb33" }
}, Y = { class: "title" }, X = { class: "checkbox-group" }, Z = {
	class: "legend",
	style: { "--color": "#2c75ff" }
}, Q = { class: "title" }, $ = { class: "checkbox-group" }, ee = {
	key: 3,
	class: "feedback"
}, te = /*#__PURE__*/ y(/* @__PURE__ */ x({
	__name: "UsagesDonnees.ce",
	props: {
		localeChoices: { type: Array },
		cloudChoices: { type: Array }
	},
	setup(s, { expose: d }) {
		let { t: m } = C(), y = o("wrapper"), x = e(1), w = e({
			1: s.localeChoices.map((e) => ({
				...e,
				isSelected: !1
			})),
			2: s.cloudChoices.map((e) => ({
				...e,
				isSelected: !1
			}))
		}), E = p(() => Object.values(w.value).flatMap((e) => e).filter((e) => e.hasValue).sort(N)), D = p(() => Object.values(w.value).flatMap((e) => e).filter((e) => !e.hasValue).sort(N)), O = p(() => x.value === 1 ? m("usages-donnees.locale-choice-title") : m("usages-donnees.cloud-choice-title")), k = p(() => x.value === 1 ? m("usages-donnees.next") : m("usages-donnees.result")), A = p(() => m(`usages-donnees.instruction-step-${x.value}`)), j = p(() => x.value === 3), M = p(() => !w.value[x.value]?.some(({ isSelected: e }) => e));
		function N(e, t) {
			return e.isSelected && t.isSelected ? 0 : e.isSelected ? -1 : +!!t.isSelected;
		}
		function P() {
			w.value = {
				1: s.localeChoices.map((e) => ({
					...e,
					isSelected: !1
				})),
				2: s.cloudChoices.map((e) => ({
					...e,
					isSelected: !1
				}))
			}, x.value = 1;
		}
		function F(e, t) {
			w.value[x.value][t].isSelected = e;
		}
		async function I() {
			x.value++, await t(), y.value.focus();
		}
		return d({ reset: P }), (e, t) => {
			let o = S("i18n");
			return r(), b("div", {
				ref_key: "wrapper",
				ref: y,
				class: v(["wrapper", [`step-${x.value}`]]),
				tabindex: "-1"
			}, [
				j.value ? c("", !0) : (r(), b("p", B, h(A.value), 1)),
				j.value ? (r(), b("form", q, [u("fieldset", null, [u("legend", J, [u("span", Y, h(e.$t("usages-donnees.last-step.title-1")), 1)]), u("div", X, [(r(!0), b(g, null, i(E.value, (e, t) => (r(), l(z, f({ key: e.label }, { ref_for: !0 }, e, {
					readonly: !0,
					index: t,
					variant: "b"
				}), null, 16, ["index"]))), 128))])]), u("fieldset", null, [u("legend", Z, [u("span", Q, h(e.$t("usages-donnees.last-step.title-2")), 1)]), u("div", $, [(r(!0), b(g, null, i(D.value, (e, t) => (r(), l(z, f({ key: e.label }, { ref_for: !0 }, e, {
					readonly: !0,
					index: t,
					variant: "c"
				}), null, 16, ["index"]))), 128))])])])) : (r(), b("form", V, [u("fieldset", null, [u("legend", null, [u("span", H, h(O.value), 1), u("span", U, [u("span", W, h(e.$t("usages-donnees.step-a11y", {
					currentStep: x.value,
					total: 2
				})), 1), u("span", G, h(x.value) + "/2", 1)])]), u("div", K, [(r(!0), b(g, null, i(w.value[x.value], (e, t) => (r(), l(z, f({ key: e.label }, { ref_for: !0 }, e, {
					index: t,
					onSelect: F
				}), null, 16, ["index"]))), 128))])]), n(T, {
					class: "pix-button",
					"is-disabled": M.value,
					onClick: I
				}, {
					default: _(() => [a(h(k.value), 1)]),
					_: 1
				}, 8, ["is-disabled"])])),
				j.value ? (r(), b("p", ee, [u("span", null, h(e.$t("usages-donnees.last-step.content.line-1")), 1), n(o, { t: "usages-donnees.last-step.content.line-2" }, {
					bold1: _(() => [u("strong", null, h(e.$t("usages-donnees.last-step.content.bold-1")), 1)]),
					bold2: _(() => [u("strong", null, h(e.$t("usages-donnees.last-step.content.bold-2")), 1)]),
					_: 1
				})])) : c("", !0)
			], 2);
		};
	}
}), [["styles", ["*{--text-blue:#122647;--background-blue:#253858;box-sizing:border-box;font-family:Nunito,Roboto,sans-serif;font-size:14px}h1,h2,h3,h4,h5,h6{color:var(--text-blue);font-family:Nunito,sans-serif}h2{color:var(--text-blue);font-size:20px}p,a,span,li{color:var(--text-blue);font-family:Roboto,sans-serif}button{background:var(--background-blue);border-radius:8px;font-size:16px;font-weight:700}button:disabled{background:#c8cfd9}input{background:#f4f5f7;border:#cdd1d9;border-radius:10px}.sr-only{clip-path:inset(50%);white-space:nowrap;border:0;width:1px;height:1px;padding:0;position:absolute;overflow:hidden}ol,ul{list-style:none}table{border-collapse:collapse;border-spacing:0}*{box-sizing:border-box;color:#122647;font-family:Nunito,Roboto,sans-serif}", ".wrapper[data-v-525ba022]{padding:0 24px 24px}.wrapper.step-3[data-v-525ba022]{padding-top:24px}.instruction[data-v-525ba022]{margin:0 0 24px}form[data-v-525ba022]{background-color:#fff;border-radius:16px;padding:16px 24px;box-shadow:0 2px 5px #4a3aff40,inset 0 -2px 5px #4a3aff26,inset 0 1px 1px #ffffff1a,inset 0 3px 4px #dfeeff1a}fieldset[data-v-525ba022]{border:none;padding:0}legend[data-v-525ba022]{justify-content:space-between;align-items:center;width:100%;margin-bottom:16px;display:flex}legend .title[data-v-525ba022]{font-size:1.25rem;font-weight:800}legend .stepper[data-v-525ba022]{aspect-ratio:1;background:#bde4ff;border-radius:50%;justify-content:center;align-self:center;align-items:center;min-width:38px;font-family:Roboto,sans-serif;font-size:.875rem;font-weight:700;display:flex}.checkbox-group[data-v-525ba022]{grid-template-columns:repeat(2,1fr);gap:16px;margin-bottom:24px;display:grid}.pix-button[data-v-525ba022]{margin:0 auto;display:block}.result fieldset[data-v-525ba022]:first-child{margin-bottom:24px}.result .legend[data-v-525ba022]{justify-content:start;gap:8px}.result .legend[data-v-525ba022]:before{content:\"\";background-color:var(--color);aspect-ratio:1;border-radius:50%;align-self:center;min-width:12px;position:relative;top:2px}.result .checkbox-group[data-v-525ba022]{grid-template-columns:repeat(4,1fr)}.feedback[data-v-525ba022]{background:#eaf1ff;border-radius:8px;margin:16px 0 0;padding:8px}.feedback[data-v-525ba022],.feedback span[data-v-525ba022]{font-family:Roboto,sans-serif;font-size:.75rem;line-height:1.125rem}.feedback span[data-v-525ba022]{margin-bottom:.4rem;display:block}@media screen and (width<=874px){.result .checkbox-group[data-v-525ba022]{grid-template-columns:repeat(2,1fr)}}@media screen and (width<=576px){.checkbox-group[data-v-525ba022]{grid-template-columns:1fr;gap:8px}.result .checkbox-group[data-v-525ba022]{grid-template-columns:1fr}}"]], ["__scopeId", "data-v-525ba022"]]);
//#endregion
//#region src/webcomponents/usages-donnees/usages-donnees.ce.js
w.addTranslationsFromGlobResults(/* #__PURE__ */ Object.assign({
	"./locales/de-AT.json": E,
	"./locales/en.json": D,
	"./locales/es-419.json": O,
	"./locales/es.json": k,
	"./locales/fr-BE.json": A,
	"./locales/fr.json": j,
	"./locales/it.json": M,
	"./locales/nl.json": N
}));
var ne = d(te, { configureApp(e) {
	w.changeLanguage(document?.documentElement?.lang || navigator.language), e.use(w);
} });
window.customElements.define("usages-donnees", ne);
//#endregion
